import { render, staticRenderFns } from "./singleDeduction.vue?vue&type=template&id=0e886c61&scoped=true"
import script from "./singleDeduction.vue?vue&type=script&lang=js"
export * from "./singleDeduction.vue?vue&type=script&lang=js"
import style0 from "./singleDeduction.vue?vue&type=style&index=0&id=0e886c61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e886c61",
  null
  
)

export default component.exports